/**
 * Utilitários para biblioteca de seções (blocos reutilizáveis).
 * Configuração da seção (cores, imagem de fundo, ondas, etc.) é preservada integralmente.
 * Imagens de upload em widgets específicos são trocadas por mockup padrão.
 */

/** Mockup genérico servido pelo frontend (public/back_log.png). */
export const SECTION_IMAGE_MOCKUP_URL = '/back_log.png';

function sanitizeWidgetContentForPreset(widget) {
  if (!widget?.content || typeof widget.content !== 'object') return widget;
  const w = { ...widget, content: { ...widget.content } };
  const c = w.content;

  switch (w.type) {
    case 'image':
      c.url = SECTION_IMAGE_MOCKUP_URL;
      break;
    case 'image-card':
      c.imageUrl = SECTION_IMAGE_MOCKUP_URL;
      break;
    case 'carousel':
      if (Array.isArray(c.slides)) {
        c.slides = c.slides.map((s) => ({
          ...s,
          url: (s?.url || '').trim() ? SECTION_IMAGE_MOCKUP_URL : '',
        }));
      }
      if (Array.isArray(c.floats)) {
        c.floats = c.floats.map((item) => ({
          ...item,
          url: (item?.url || '').trim() ? SECTION_IMAGE_MOCKUP_URL : '',
        }));
      }
      break;
    case 'image-gallery':
      c.images = [];
      break;
    case 'social-card':
      c.bannerUrl = '';
      c.avatarMode = 'mockup';
      c.mockupAvatarUrl = '';
      break;
    default:
      break;
  }
  return w;
}

function walkRowTreeForPreset(row) {
  if (!row || typeof row !== 'object') return row;
  const r = { ...row };
  if (r.config) r.config = { ...r.config };
  r.columns = (r.columns || []).map((col) => {
    const nc = { ...col };
    if (nc.config) nc.config = { ...nc.config };
    nc.widgets = (nc.widgets || []).map(sanitizeWidgetContentForPreset);
    if (Array.isArray(nc.nestedRows) && nc.nestedRows.length) {
      nc.nestedRows = nc.nestedRows.map(walkRowTreeForPreset);
    }
    return nc;
  });
  return r;
}

/** Prepara uma linha (com blocos aninhados) para persistência na biblioteca. */
export function prepareRowForSectionPreset(row) {
  const cloned = JSON.parse(JSON.stringify(row));
  return walkRowTreeForPreset(cloned);
}

/** Schema armazenado no banco para uma seção. */
export function buildSectionPresetSchema(row) {
  return {
    kind: 'section',
    version: 1,
    rows: [prepareRowForSectionPreset(row)],
  };
}

/** Extrai rows de schema_json da API (objeto ou string). */
export function parseSectionPresetRows(raw) {
  if (raw == null || raw === '') return [];
  let schema = raw;
  if (typeof schema === 'string') {
    const t = schema.trim();
    if (!t) return [];
    try {
      schema = JSON.parse(t);
    } catch {
      return [];
    }
  }
  while (typeof schema === 'string') {
    try {
      schema = JSON.parse(schema);
    } catch {
      break;
    }
  }
  if (Array.isArray(schema)) return schema;
  if (schema && Array.isArray(schema.rows)) return schema.rows;
  return [];
}
